import { theme } from '@kdk/shared/theme';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { AuthProvider } from '../auth/AuthProvider';
import { ToastProvider } from '../shared-ui/ToastProvider';
import { themeModeStorage } from './themeModeStorage';

type Props = { children: ReactNode; queryClient?: QueryClient };

const createClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    },
  });

export const AppProviders = ({ children, queryClient }: Props) => {
  const [defaultClient] = useState(createClient);
  return (
    <ThemeProvider
      theme={theme}
      defaultMode="light"
      storageManager={themeModeStorage}
      noSsr
      disableTransitionOnChange
    >
      <CssBaseline enableColorScheme />
      <QueryClientProvider client={queryClient ?? defaultClient}>
        <ToastProvider>
          <AuthProvider>{children}</AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
